import type { PartialDeep } from 'type-fest';
import { Configuration } from '../defaultConfig';

const stageConfig: PartialDeep<Configuration> = {
  services: {
    civicAnalytics: {
      endpoint: 'http://localhost:3001/dev/analytics',
      source: 'passApi_local',
    },
    configEndpoint: 'http://localhost:3001/dev',
    validation: {
      validationEndpoint: 'http://localhost:3001/dev',
      pollingIntervalInSeconds: 1,
    },
    sip: {
      sipEndpoint: 'http://localhost:3001/dev/scopeRequest',
    },
    networkRetryConfig: {
      defaultRetries: 1,
      userControlledRetries: 1,
      retryTimeoutMs: {
        1: 1,
        2: 1,
        3: 1,
        4: 1,
      },
      maxAllowedRetryLoops: 1,
    },
  },
};

export default stageConfig;
